module.exports = __webpack_public_path__ + "static/media/cat.327e46c9.jpg";